







































































import { Component, Mixins, Prop, PropSync, Watch } from 'vue-property-decorator';
import Spinner from '@/commoncomponents/spinner/Spinner.vue';
import BaseCard from '@/components/familyPortal/sessionCard/BaseCard.vue';
import SessionPriceTag from '@/components/familyPortal/sessionCard/SessionPriceTag.vue';
import APP_CONST from '@/constants/AppConst';
import { ScreenText } from '@/lang/ScreenText';
import AccountSettings from '@/mixins/accountSettings.mixin';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import { AddCartItemActionPayload } from '@/Model/checkout/cart/types';
import { CatalogSession } from '@/Model/sessions/catalogTypes';
import CartStoreModule from '@/store/modules/checkout/cart/module';
import APP_UTILITIES from '@/utilities/commonFunctions';

@Component({
  components: {
    Spinner,
    'SessionPriceTag': SessionPriceTag,
    'BaseCard': BaseCard,
  }
})
export default class CatalogCard extends Mixins(DeviceWidthCheckerMixin, AccountSettings) {
  @Prop({ type: Object, required: true }) readonly session!: CatalogSession;
  @Prop({ type: Boolean }) readonly hasOnlinePayments!: boolean;
  @PropSync('isAutomaticDiscountEnabled', { type: Boolean }) isAutomaticDiscountEnabledSync!: boolean;

  public childrenSelection = 1;
  public isCustomerPortalEnabled = false;
  public isPaymentPlanFlagEnabled = false;

  readonly screenText = new ScreenText();
  APP_CONST = APP_CONST;

  get childrenLabelText(): string {
    return this.screenText.getScreenText('CATALOG_SESSION_CHILDREN_LABEL');
  }

  get addToCartText(): string {
    return this.screenText.getScreenText('CATALOG_SESSION_ADD_TO_CART');
  }

  get viewDetails(): string {
    return this.screenText.getScreenText('CATALOG_SESSION_VIEW_DETAILS');
  }

  get isAddingSessionToCart(): boolean {
    return CartStoreModule.isAddingToCart;
  }

  get currentInteractionSessionId(): number | null {
    return CartStoreModule.currentInteractionSessionId;
  }

  @Watch('childrenSelection', { deep: true })
  watchvalue() {
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.PRODUCT_CATALOG.addChildInCatalogView);
  }

  navigateToDetails(sessionId: number) {
    this.$router.push(`${APP_CONST.APP_ROUTES.SESSION_DETAILS.path}/${sessionId}`);
  }

  addSessionToCart() {
    const cartItem = {
      quantity: this.childrenSelection,
      session: this.session,
      shouldNotifyUser: true
    } as AddCartItemActionPayload;

    CartStoreModule.addCartItem(cartItem);
    const segmentProperties = {
      product_id: this.session.sessionId,
      product_name: this.session.sessionName,
      product_price: this.session.price,
      participant_quantity: this.childrenSelection
    };
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.PRODUCT_CATALOG.addSessionToCart, segmentProperties);
  }

  async mounted() {
    const customerPortalFlag = await APP_UTILITIES.getFeatureFlag(APP_CONST.FEATURE_KEYS.staffCustomerPortal);
    this.isCustomerPortalEnabled = customerPortalFlag;
    this.isPaymentPlanFlagEnabled = await APP_UTILITIES.getFeatureFlag(APP_CONST.FEATURE_KEYS.paymentPlans);
  }
}
